import InfoTooltip from 'Components/InfoTooltip'
import { AllowedActivationMethods } from 'Services/ProductManagement/Features/Product/types'
import { Typography } from '@mui/material'
import { t } from 'ttag'

function AllowedActivationMethodsInfoTooltip() {
  return (
    <InfoTooltip
      title={
        <>
          <Typography variant="body2">
            {t`At the moment there are three different activation methods:`}
          </Typography>
          <Typography variant="body2">
            <ul>
              <li>
                <strong key={AllowedActivationMethods.PURCHASE}>{t`Purchase`}</strong> -{' '}
                {t`The products validity starts immediately upon purchase.`}
              </li>
              <li>
                <strong key={AllowedActivationMethods.FIRST_USE}>{t`First use`}</strong> -{' '}
                {t`The products validity starts when the product is used for the first time.`}
              </li>
              <li>
                <strong key={AllowedActivationMethods.TIMED}>{t`Timed`}</strong> -{' '}
                {t`The product can be purchase beforehand and its validity is activated after a predefined time.`}
              </li>
            </ul>
          </Typography>
        </>
      }
    />
  )
}

export default AllowedActivationMethodsInfoTooltip
